import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { KnowledgeSource } from '../../../core/models/knowledge-source';
import { KnowledgeSourceSelector } from '../knowledge-source-selector/knowledge-source-selector';

@Component({
  selector: 'app-message-composer',
  standalone: true,
  imports: [FormsModule, TranslocoPipe, KnowledgeSourceSelector],
  templateUrl: './message-composer.html',
  host: { class: 'block shrink-0' },
})
export class MessageComposer {
  @Input() disabled = false;
  @Input() availableKnowledgeSources: KnowledgeSource[] = ['public'];
  @Input() selectedKnowledgeSources: KnowledgeSource[] = ['public'];
  @Output() send = new EventEmitter<string>();
  @Output() selectedKnowledgeSourcesChange = new EventEmitter<KnowledgeSource[]>();
  @ViewChild('textarea') private textarea?: ElementRef<HTMLTextAreaElement>;
  protected value = '';

  protected handleKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.submit();
    }
  }

  protected resize(): void {
    const element = this.textarea?.nativeElement;
    if (!element) return;
    element.style.height = 'auto';
    element.style.height = `${Math.min(element.scrollHeight, 160)}px`;
  }

  protected submit(): void {
    const message = this.value.trim();
    if (!message || this.disabled) return;
    this.send.emit(message);
    this.value = '';
    queueMicrotask(() => this.resize());
  }
}
